import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const AccountChildrenButtonAccountFragmentDoc = gql`
  fragment AccountChildrenButtonAccount on Account {
    id
    children {
      totalCount
    }
  }
` as unknown as DocumentNode<Types.AccountChildrenButtonAccountFragment, unknown>
